import React from "react";
import { useTranslation } from "react-i18next";
import { useInView } from "react-intersection-observer";
import "animate.css";
import { Link } from "react-router-dom";
import { phong } from "../assets/images";
const RoomDescription = () => {
  const { t } = useTranslation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <section
      ref={ref}
      className={`py-12 px-6 text-center relative bg-gray-200 ${
        inView ? "animate__animated animate__fadeInUp" : "opacity-0"
      }`}
    >
      {/* <div className="bg-slate-400 absolute left-0 right-0 w-full h-full"></div> */}
      <h2 className="text-[35px] font-medium text-[#D4AF37] font-cormorant">
        {t("HOTEL_NAME")}
      </h2>
      <h3 className="text-[28px]  font-medium font-cormorant mt-2 uppercase italic">
        {t("HOTEL_TAGLINE")}
      </h3>
      <p className="mb-4 mt-4 mx-auto font-medium text-gray-600">{t("HOTEL_DES1")}</p>
      <Link
        to={"/about"}
        className="border text-[14px] border-yellow-500 hover:bg-[#D4AF37] hover:text-white duration-200 text-gray-600 px-4 py-2 rounded font-greatVibes"
      >
        {t("LEARN_MORE")}
      </Link>
      <div className="w-full h-96 overflow-hidden rounded mt-6">
        <img
          src={phong}
          alt={t("ROOM_IMAGE_ALT")}
          className=" w-full h-full hover:scale-105 duration-300 object-cover rounded"
        />
      </div>
      <p className="mt-4 text-gray-600 font-cormorant  text-left font-semibold italic">
        {t("home_title_chill")}
      </p>
    </section>
  );
};

export default RoomDescription;
